import { Pipe, PipeTransform } from '@angular/core';
import { portalDate } from './portal-format';

@Pipe({ name: 'localizedDate', pure: false })
export class LocalizedDatePipe implements PipeTransform {
	transform(value: any, format = 'mediumDate'): string {
		return portalDate(value, format);
	}
}
